/* santo-anim: one shared IntersectionObserver for santo-anim.css. Off with reduced motion, without IO and in the editor. */
(function(){
  var d=document,M=window.matchMedia;
  if(!('IntersectionObserver' in window)||!M||M('(prefers-reduced-motion: reduce)').matches||(window.Shopify&&Shopify.designMode))return;
  var hero=d.querySelector('[id^="shopify-section-template"]');
  function each(sel,fn){[].forEach.call(d.querySelectorAll(sel),function(e){
    if(!(hero&&hero.contains(e))&&!e.closest('.title-panel,[data-buybox],.story-eyebrow'))fn(e);
  });}
  var io=new IntersectionObserver(function(list){list.forEach(function(en){
    var t=en.target,c=t.classList;
    if(c.contains('a-sway')){c.toggle('a-run',en.isIntersecting);return;}
    if(en.isIntersecting){c.add(c.contains('a-farm')?'a-wave':'a-on');io.unobserve(t);}
  });},{rootMargin:'0px 0px -10% 0px'});
  each('.rcard .stars,.rev-agg .stars',function(s){
    var t=s.textContent.trim();
    if(!/^[★☆]{1,5}$/.test(t))return;
    s.innerHTML=t.split('').map(function(g){return '<span class="a-st">'+g+'</span>';}).join('');
    io.observe(s);
  });
  each('.eyebrow',function(e){
    var n=e.nextElementSibling;
    e.classList.add('a-eb');
    if(n&&/^H[1-4]$/.test(n.tagName))n.classList.add('a-h');
    io.observe(e);
  });
  each('.taste-media',function(m){if(m.querySelector('.pill')){m.classList.add('a-pills');io.observe(m);}});
  each('.people-flank',function(f){f.classList.add('a-sway');io.observe(f);});
  each('.foot-farmer',function(f){
    var w=d.createElement('span'),a=f.cloneNode();
    w.className='a-farm';a.className='a-arm';
    f.parentNode.insertBefore(w,f);w.appendChild(a);w.appendChild(f);
    a.addEventListener('animationend',function(){w.classList.remove('a-wave');});
    w.addEventListener('mouseenter',function(){w.classList.add('a-wave');});
    w.addEventListener('click',function(){w.classList.add('a-wave');});
    io.observe(w);
  });
  d.documentElement.classList.add('anim-ready');
})();
